<template>
  <div>
    <span> </span>

    <!-- <div class="pr-10 py-0">
      <img
        src="https://ilfamilyviolence.icjia-api.cloud/uploads/logo3_purple_black_56edb1b2e0.png"
        lazy-src="https://ilfamilyviolence.icjia-api.cloud/uploads/logo3_purple_black_56edb1b2e0.png"
        alt="Illinois HEALS"
        width="55"
        style="float: left; padding-right: 15px; padding-bottom: 5px"
        class="hover"
      />
    </div> -->
    Family Violence Coordinating Councils, at both the state and local/circuit
    levels, provide a forum to improve the institutional, professional and
    community response to family violence including child abuse, domestic abuse,
    and elder abuse. Councils provide professional education and prevention;
    coordinate interventions and services for victims and perpetrators; and
    contribute to both the improvement of the legal system and the
    administration of justice.
  </div>
</template>

<script>
import { getImageURL } from "@/services/Image";
export default {
  data() {
    return {
      getImageURL,
    };
  },
  methods: {
    getImagePath(url, imgWidth = 0, imgHeight = 0, imageQuality = 100) {
      let imgPath;
      imgPath = `${this.$myApp.config.clientURL}${this.$myApp.config.publicPath}${url}`;
      const thumborImgPath = getImageURL(
        imgPath,
        imgWidth,
        imgHeight,
        imageQuality
      );
      //console.log("splash path: ", thumborImgPath);
      return thumborImgPath;
    },
  },
};
</script>

<style lang="scss" scoped></style>
